import { useEffect } from "react";

export default function useSocialEmbed(content) {
  useEffect(() => {
    /* ===== TIKTOK ===== */
    if (!document.querySelector('script[src="https://www.tiktok.com/embed.js"]')) {
      const s = document.createElement("script");
      s.src = "https://www.tiktok.com/embed.js";
      s.async = true;
      document.body.appendChild(s);
    }

    /* ===== INSTAGRAM ===== */
    const runInstagram = () => {
      window.instgrm?.Embeds?.process();
    };

    if (!document.querySelector('script[src="https://www.instagram.com/embed.js"]')) {
      const s = document.createElement("script");
      s.src = "https://www.instagram.com/embed.js";
      s.async = true;
      s.onload = runInstagram; // 🔥 WAJIB
      document.body.appendChild(s);
    } else {
      runInstagram();
    }

    /* ===== TWITTER / X ===== */
    if (!document.querySelector('script[src="https://platform.twitter.com/widgets.js"]')) {
      const s = document.createElement("script");
      s.src = "https://platform.twitter.com/widgets.js";
      s.async = true;
      document.body.appendChild(s);
    } else {
      window.twttr?.widgets?.load();
    }
  }, [content]);
}
